/* eslint-disable import/no-default-export */
import { MockList } from '@graphql-tools/mock';

export default () => ({
  completed: true,
  roles: () => new MockList([0, 2]),
  qualifications: () => new MockList([0, 2]),
});
